import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(undefined);

export const translations = {
  th: {
    // Navigation
    nav_dashboard: 'แดชบอร์ด',
    nav_transactions: 'รายการสั่งซื้อ',
    nav_products: 'สินค้า',
    nav_stores: 'ร้านค้า',
    nav_users: 'ผู้ใช้งาน',
    nav_chat: 'แชท',

    // Common
    search: 'ค้นหา...',
    no_data: 'ไม่พบข้อมูล',
    loading: 'กำลังโหลด...',
    save: 'บันทึก',
    saving: 'กำลังบันทึก...',
    cancel: 'ยกเลิก',
    edit: 'แก้ไข',
    delete: 'ลบ',
    add: 'เพิ่ม',
    view_all: 'ดูทั้งหมด',
    status: 'สถานะ',
    created_date: 'วันที่สร้าง',
    confirm: 'ยืนยัน',
    close: 'ปิด',

    // Dashboard
    dashboard_title: 'แดชบอร์ด',
    stat_transactions: 'รายการทั้งหมด',
    stat_products: 'สินค้าทั้งหมด',
    stat_stores: 'ร้านค้าทั้งหมด',
    stat_users: 'ผู้ใช้งานทั้งหมด',
    recent_transactions: 'รายการล่าสุด',
    realtime_update: 'อัพเดตแบบ Real-time',
    date_range: 'ช่วงวันที่',
    start_date: 'วันเริ่มต้น',
    end_date: 'วันสิ้นสุด',
    apply_filter: 'กรอง',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    period_summary: 'สรุปช่วงเวลา',
    total_revenue: 'รายได้รวม',
    orders_in_period: 'ออเดอร์ในช่วง',
    avg_order_value: 'ออเดอร์เฉลี่ย',
    new_users_period: 'ผู้ใช้ใหม่',
    revenue_trend: 'แนวโน้มรายได้',
    top_products: 'สินค้าขายดี',
    top_stores: 'ร้านยอดนิยม',
    mock_data_notice: 'ข้อมูลจำลอง',
    col_revenue: 'รายได้',
    col_sales: 'ยอดขาย',
    col_orders: 'ออเดอร์',
    baht_unit: '฿',
    orders_unit: 'ออเดอร์',
    days_unit: 'วัน',

    // Transactions table
    col_number: 'เลขที่',
    col_store: 'ร้านค้า',
    col_customer: 'ลูกค้า',
    col_products: 'สินค้า',
    col_status: 'สถานะ',
    col_date: 'วันที่สร้าง',
    transactions_title: 'รายการสั่งซื้อ',
    search_transactions: 'ค้นหาเลขที่, ลูกค้า...',

    // Products
    products_title: 'สินค้า',
    add_product: 'เพิ่มสินค้า',
    create_product: 'สร้างสินค้า',
    search_products: 'ค้นหาสินค้า...',
    col_sku: 'SKU',
    col_product_name: 'ชื่อสินค้า',
    col_category: 'หมวดหมู่',
    product_image: 'รูปภาพสินค้า',
    select_category: '-- เลือกหมวดหมู่ --',
    name_th: 'ชื่อ (TH)',
    name_en: 'ชื่อ (EN)',
    description_th: 'รายละเอียด (TH)',
    description_en: 'รายละเอียด (EN)',
    default_price: 'ราคา (ค่าเริ่มต้น)',
    col_product_group: 'กลุ่มสินค้า',
    select_product_group: '-- เลือกกลุ่มสินค้า --',
    product_basic_info: 'ข้อมูลทั่วไป',
    product_pricing_info: 'ราคา & ข้อมูลอื่น',

    // Stores
    stores_title: 'ร้านค้า',
    add_store: 'เพิ่มร้านค้า',
    create_store: 'สร้างร้านค้า',
    search_stores: 'ค้นหาร้านค้า...',
    col_store_name: 'ชื่อร้าน',
    col_owner: 'เจ้าของ',
    col_items: 'สินค้า',
    store_owner: 'เจ้าของร้าน',
    select_owner: '-- เลือกเจ้าของ --',
    store_name: 'ชื่อร้าน',
    latitude: 'ละติจูด',
    longitude: 'ลองจิจูด',
    radius_km: 'รัศมี (km)',
    sequence: 'ลำดับ',
    google_maps_link: 'ลิงก์ Google Maps',
    google_maps_placeholder: 'วางลิงก์ Google Maps เพื่อกรอกพิกัดอัตโนมัติ...',
    map_coords_found: 'พบพิกัดจากลิงก์เรียบร้อย',
    map_coords_not_found: 'ไม่พบพิกัดในลิงก์นี้',
    store_basic_info: 'ข้อมูลทั่วไป',
    location_info: 'ข้อมูลพิกัดสถานที่',

    // Store Details / Product-to-Store
    add_product_to_store: 'เพิ่มสินค้าในร้าน',
    edit_product_in_store: 'แก้ไขรายการสินค้า',
    select_product: '-- เลือกสินค้า --',
    cost_price: 'ราคาทุน',
    selling_price: 'ราคาขาย',
    stock_qty: 'จำนวนคงเหลือ',
    discount_label: 'ส่วนลด',
    margin_label: 'Margin',
    already_added: '(เพิ่มแล้ว)',
    edit_store_info: 'แก้ไขข้อมูลร้านค้า',
    store_image: 'รูปภาพร้าน',
    general_info: 'ข้อมูลทั่วไป',
    owner_label: 'เจ้าของ',

    // Users
    users_title: 'ผู้ใช้งาน',
    add_user: 'เพิ่มผู้ใช้',
    create_user: 'สร้างผู้ใช้',
    search_users: 'ค้นหาผู้ใช้...',
    col_user: 'ผู้ใช้',
    col_phone: 'เบอร์โทร',
    col_email: 'อีเมล',
    col_role: 'บทบาท',
    col_user_type: 'ประเภท',
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    email: 'อีเมล',
    phone: 'เบอร์โทร',
    user_type: 'ประเภทผู้ใช้',

    // Settings
    settings_title: 'ตั้งค่า',
    edit_profile: 'แก้ไขโปรไฟล์',
    profile_subtitle: 'อัปเดตข้อมูลส่วนตัวของคุณ',
    profile_photo: 'รูปโปรไฟล์',
    username_readonly: 'ไม่สามารถเปลี่ยน username ได้',
    account_info: 'ข้อมูลบัญชี',
    user_id: 'User ID',
    entity_id: 'Entity ID',
    active: 'ใช้งาน',
    inactive: 'ปิดใช้งาน',
    member_since: 'สร้างเมื่อ',
    change_password: 'เปลี่ยนรหัสผ่าน',
    change_password_subtitle: 'กรอกรหัสผ่านใหม่ที่ต้องการ',
    new_password: 'รหัสผ่านใหม่',
    confirm_password: 'ยืนยันรหัสผ่านใหม่',
    password_min_length: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
    password_mismatch: 'รหัสผ่านไม่ตรงกัน',
    changing_password: 'กำลังบันทึก...',
    change_password_success: 'เปลี่ยนรหัสผ่านแล้ว',
    change_password_error: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',

    // Topbar / Profile dropdown
    profile: 'โปรไฟล์',
    settings: 'ตั้งค่า',
    logout: 'ออกจากระบบ',
    online: 'ออนไลน์',
    offline: 'ออฟไลน์',

    // Sidebar
    administrator: 'ผู้ดูแลระบบ',

    // Addresses box
    address_list: 'รายการที่อยู่',
    add_address: 'เพิ่มที่อยู่',
    edit_address: 'แก้ไขที่อยู่',
    no_address: 'ยังไม่มีที่อยู่',
    recipient_info: 'ข้อมูลผู้รับ',
    recipient_name: 'ชื่อผู้รับ',
    recipient_phone: 'เบอร์ผู้รับ',
    address_info: 'ที่อยู่',
    address_line1: 'ที่อยู่บรรทัดที่ 1',
    address_line2: 'ที่อยู่บรรทัดที่ 2',
    postal_code: 'รหัสไปรษณีย์',
    country_label: 'ประเทศ',
    gps_coordinates: 'พิกัด GPS',
    set_as_default: 'ตั้งเป็นค่าเริ่มต้น',
    unset_default: 'ยกเลิกค่าเริ่มต้น',
    default_badge: 'ค่าเริ่มต้น',
    delivery_address_info: 'ข้อมูลผู้รับและที่อยู่จัดส่ง',

    // Recent transactions box
    recent_list: 'รายการล่าสุด',
    no_transactions: 'ยังไม่มีรายการ',

    // Topbar logo
    logo_badge: 'แอดมิน',
  },
  en: {
    // Navigation
    nav_dashboard: 'Dashboard',
    nav_transactions: 'Transactions',
    nav_products: 'Products',
    nav_stores: 'Stores',
    nav_users: 'Users',
    nav_chat: 'Chat',

    // Common
    search: 'Search...',
    no_data: 'No data found',
    loading: 'Loading...',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    view_all: 'View All',
    status: 'Status',
    created_date: 'Created Date',
    confirm: 'Confirm',
    close: 'Close',

    // Dashboard
    dashboard_title: 'Dashboard',
    stat_transactions: 'Total Transactions',
    stat_products: 'Total Products',
    stat_stores: 'Total Stores',
    stat_users: 'Total Users',
    recent_transactions: 'Recent Transactions',
    realtime_update: 'Real-time updates',
    date_range: 'Date Range',
    start_date: 'Start Date',
    end_date: 'End Date',
    apply_filter: 'Apply',
    today: 'Today',
    yesterday: 'Yesterday',
    period_summary: 'Period Summary',
    total_revenue: 'Total Revenue',
    orders_in_period: 'Orders in Period',
    avg_order_value: 'Avg. Order Value',
    new_users_period: 'New Users',
    revenue_trend: 'Revenue Trend',
    top_products: 'Top Products',
    top_stores: 'Top Stores',
    mock_data_notice: 'Mock Data',
    col_revenue: 'Revenue',
    col_sales: 'Sales',
    col_orders: 'Orders',
    baht_unit: '฿',
    orders_unit: 'orders',
    days_unit: 'days',

    // Transactions table
    col_number: 'Number',
    col_store: 'Store',
    col_customer: 'Customer',
    col_products: 'Products',
    col_status: 'Status',
    col_date: 'Created Date',
    transactions_title: 'Transactions',
    search_transactions: 'Search number, customer...',

    // Products
    products_title: 'Products',
    add_product: 'Add Product',
    create_product: 'Create Product',
    search_products: 'Search products...',
    col_sku: 'SKU',
    col_product_name: 'Product Name',
    col_category: 'Category',
    product_image: 'Product Image',
    select_category: '-- Select Category --',
    name_th: 'Name (TH)',
    name_en: 'Name (EN)',
    description_th: 'Description (TH)',
    description_en: 'Description (EN)',
    default_price: 'Price (Default)',
    col_product_group: 'Product Group',
    select_product_group: '-- Select Product Group --',
    product_basic_info: 'Basic Information',
    product_pricing_info: 'Pricing & Other',

    // Stores
    stores_title: 'Stores',
    add_store: 'Add Store',
    create_store: 'Create Store',
    search_stores: 'Search stores...',
    col_store_name: 'Store Name',
    col_owner: 'Owner',
    col_items: 'Products',
    store_owner: 'Store Owner',
    select_owner: '-- Select Owner --',
    store_name: 'Store Name',
    latitude: 'Latitude',
    longitude: 'Longitude',
    radius_km: 'Radius (km)',
    sequence: 'Sequence',
    google_maps_link: 'Google Maps Link',
    google_maps_placeholder: 'Paste a Google Maps link to autofill coordinates...',
    map_coords_found: 'Coordinates found from link',
    map_coords_not_found: 'No coordinates found in this link',
    store_basic_info: 'Basic Information',
    location_info: 'Location Coordinates',

    // Store Details / Product-to-Store
    add_product_to_store: 'Add Product to Store',
    edit_product_in_store: 'Edit Product in Store',
    select_product: '-- Select Product --',
    cost_price: 'Cost Price',
    selling_price: 'Selling Price',
    stock_qty: 'Stock Quantity',
    discount_label: 'Discount',
    margin_label: 'Margin',
    already_added: '(Already Added)',
    edit_store_info: 'Edit Store',
    store_image: 'Store Image',
    general_info: 'General Information',
    owner_label: 'Owner',

    // Users
    users_title: 'Users',
    add_user: 'Add User',
    create_user: 'Create User',
    search_users: 'Search users...',
    col_user: 'User',
    col_phone: 'Phone',
    col_email: 'Email',
    col_role: 'Role',
    col_user_type: 'Type',
    username: 'Username',
    password: 'Password',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    user_type: 'User Type',

    // Settings
    settings_title: 'Settings',
    edit_profile: 'Edit Profile',
    profile_subtitle: 'Update your personal information',
    profile_photo: 'Profile Photo',
    username_readonly: 'Username cannot be changed',
    account_info: 'Account Information',
    user_id: 'User ID',
    entity_id: 'Entity ID',
    active: 'Active',
    inactive: 'Inactive',
    member_since: 'Member since',
    change_password: 'Change Password',
    change_password_subtitle: 'Enter your new password below',
    new_password: 'New Password',
    confirm_password: 'Confirm New Password',
    password_min_length: 'Password must be at least 6 characters',
    password_mismatch: 'Passwords do not match',
    changing_password: 'Saving...',
    change_password_success: 'Password changed successfully',
    change_password_error: 'Failed to change password',

    // Topbar / Profile dropdown
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    online: 'Online',
    offline: 'Offline',

    // Sidebar
    administrator: 'Administrator',

    // Addresses box
    address_list: 'Address List',
    add_address: 'Add Address',
    edit_address: 'Edit Address',
    no_address: 'No addresses yet',
    recipient_info: 'Recipient Info',
    recipient_name: 'Recipient Name',
    recipient_phone: 'Recipient Phone',
    address_info: 'Address',
    address_line1: 'Address Line 1',
    address_line2: 'Address Line 2',
    postal_code: 'Postal Code',
    country_label: 'Country',
    gps_coordinates: 'GPS Coordinates',
    set_as_default: 'Set as Default',
    unset_default: 'Unset Default',
    default_badge: 'Default',
    delivery_address_info: 'Recipient & delivery address',

    // Recent transactions box
    recent_list: 'Recent Transactions',
    no_transactions: 'No transactions yet',

    // Topbar logo
    logo_badge: 'Admin',
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'th');

  const toggleLang = () => {
    const next = lang === 'th' ? 'en' : 'th';
    setLang(next);
    localStorage.setItem('lang', next);
  };

  const t = (key) => translations[lang]?.[key] ?? translations.th[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
